import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceBehfa_ChangeOperation_Interface } from 'src/app/Interface/DeviceBehfa_ChangeOperation_Interface';
import { DeviceBehfa_Gostareh_Interface } from 'src/app/Interface/DeviceBehfa_Gostareh_Interface';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceBehfaService {

  constructor(private http: HttpClient) { }
  GetRecord(Description: String, Manufacturer: String, Model: String, Code: String, GroupFirst: number, GroupSecond: number, PageIndex: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa?Description=" + Description
      + "&Manufacturer=" + Manufacturer
      + "&Model=" + Model
      + "&Code=" + Code
      + "&GroupFirst=" + GroupFirst
      + "&GroupSecond=" + GroupSecond
      + "&PageIndex=" + PageIndex
      ).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetSearchBehfaDeviceActive(CodeSearch: string,
      DateSearch: string,
      withFilterGroup: boolean,
      GroupFirst: number,
      GroupSecond: number,): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetSearchBehfaDeviceActive?DateSearch=" + DateSearch
      + "&CodeSearch=" + CodeSearch
      + "&GroupFirst=" + GroupFirst
      + "&withFilterGroup=" + withFilterGroup
      + "&GroupSecond=" + GroupSecond).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

  GetSearchBehfaDeviceUnRepair(CodeSearch: string): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetSearchBehfaDeviceUnRepair?CodeSearch=" + CodeSearch).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

  GetRepair(): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRepair").pipe(
      map(data => {
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }

  GetFirstUserRepair(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetFirstUserRepair").pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetRecordDowloadUpload(StartSearchDate: String,
    EndSearchDate: String,
    ExpertCalibration: String,
    CodeBehfa: String,
    Filter_Type_Lap: number): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRecordDowloadUploadStartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&ExpertCalibration=" + ExpertCalibration
      + "&CodeBehfa=" + CodeBehfa
      + "&Filter_Type_Lap=" + Filter_Type_Lap).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

  GetDetailCount(): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetDetailCount").pipe(
      map(data => {
        return data as any
      })
    )
  }


  GetRepairAction(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRepairAction?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetRecordConfirmUpload(): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRecordConfirmUpload").pipe(
      map(data => {
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }

  GetDeviceBehfaGozareshKarkard(
    datepickerInputStartDaryaft: String,
    datepickerInputEndDaryaft: String,
    datepickerInputStartTahvil: String,
    datepickerInputEndTahvil: String,
    selectedUser: String,
  ): Observable<Array<DeviceBehfa_Interface>> {

    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      datepickerInputStartDaryaft: datepickerInputStartDaryaft,
      datepickerInputEndDaryaft: datepickerInputEndDaryaft,
      datepickerInputStartTahvil: datepickerInputStartTahvil,
      datepickerInputEndTahvil: datepickerInputEndTahvil,
      selectedUser: selectedUser,
    }

    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/GetDeviceBehfaGozareshKarkard", body, { headers }).pipe(
      map(data => {
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }



  GetRecordCalibration(id:Number): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRecordCalibration?id=" + id).pipe(
      map(data => {
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }

  GetRecordCalibrationReception(): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRecordCalibrationReception").pipe(
      map(data => {
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }

  GetDeviceBehfarole(
    id: number,): Observable<Array<Nav_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/DeviceBehfa/GetDeviceBehfarole?id=" + id).pipe(
        map(data => {
          return data as Array<Nav_Interface>
        })
      )
  }


  GetSingle(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetSingle?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetInfobyQR(id: String): Observable<General_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetInfobyQR?qr=" + id).pipe(
      map(data => {
        return data as General_Interface
      })
    )
  }

  GetChangeOperation(id: number): Observable<Array<DeviceBehfa_ChangeOperation_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetChangeOperation?id=" + id).pipe(
      map(data => {
        return data as Array<DeviceBehfa_ChangeOperation_Interface>
      })
    )
  }

  AddDevice(model: DeviceBehfa_Interface,
    file: Array<string>,
    gostareh: Array<DeviceBehfa_Gostareh_Interface>,
    fixer: Array<Number>,
    AfradMojaz: Array<Number>): Observable<DeviceBehfa_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_Gostareh: Array<any> = []
    for (let item of gostareh) {
      Local_Gostareh.push({
        id: item.id,
        deviceBehfa_id: 0,
        max: item.max,
        min: item.min,
        zineh: item.zineh,
        vahed_id: item.vahed_id,
        error: item.error,
        error_vahed_id: item.error_vahed_id,
      })
    }


    var body = {
      id: model.id,
      count: model.count,
      group_id: model.group_id,
      needCalibration: model.needCalibration,
      description: model.description,
      manufacturer: model.manufacturer,
      model: model.model,
      codeBEHFA: model.codeBEHFA,
      serial: model.serial,
      countery: model.countery,
      seller: model.seller,
      sellerContractor: model.SellerContractor,
      price: model.price,
      priceVahed: model.priceVahed,
      dateBuy: model.dateBuy,
      dateRun: model.dateRun,
      type: model.type,

      scopework: model.scopework,
      acceptanceCriteria: model.acceptanceCriteria,
      initialStatus: model.initialStatus,
      calibrationPeriod: model.calibrationPeriod,
      warningTime: model.warningTime,
      technicalSpecifications: model.technicalSpecifications,
      technicalDsc: model.technicalDsc,
      environmentalConditions: model.environmentalConditions,
      jobAlerts: model.jobAlerts,
      conditionKeep: model.conditionKeep,
      conditionTransport: model.conditionTransport,

      certificateNo: model.certificateNo,
      calibratingCompany: model.calibratingCompany,
      calibratingCustomer: model.calibratingCustomer,
      calibratingName: model.calibratingName,
      calibratingNameType: model.calibratingNameType,
      uncertainty: model.uncertainty,
      calDueType: model.calDueType,
      calDueMiladi: model.calDueMiladi,
      calDueShamsi: model.calDueShamsi,
      calDATEType: model.calDATEType,
      calDATEMiladi: model.calDATEMiladi,
      calDATEShamsi: model.calDATEShamsi,
      file: file,

      gostateh: Local_Gostareh,
      fixer: fixer,
      expert_calibration: AfradMojaz,

      calibratingprice: model.calibratingprice,
      calibratingpriceVahed: model.calibratingpriceVahed,

      cabinet_id: model.cabinet_id,
      category_id: model.category_id,
    }




    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/Add", body, { headers }).pipe(
      map(data => {
        return data as DeviceBehfa_Interface
      })
    )

  }

  EditDevice(model: DeviceBehfa_Interface,
    file: Array<string>,
    gostareh: Array<DeviceBehfa_Gostareh_Interface>,
    fixer: Array<Number>,
    AfradMojaz: Array<Number>): Observable<DeviceBehfa_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_Gostareh: Array<any> = []
    for (let item of gostareh) {
      Local_Gostareh.push({
        id: item.id,
        deviceBehfa_id: 0,
        max: item.max,
        min: item.min,
        zineh: item.zineh,
        vahed_id: item.vahed_id,
        error: item.error,
        error_vahed_id: item.error_vahed_id,
      })
    }

    var body = {
      id: model.id,
      group_id: model.group_id,
      count: model.count,
      needCalibration: model.needCalibration,
      description: model.description,
      manufacturer: model.manufacturer,
      model: model.model,
      codeBEHFA: model.codeBEHFA,
      serial: model.serial,
      countery: model.countery,
      seller: model.seller,
      sellerContractor: model.SellerContractor,
      price: model.price,
      priceVahed: model.priceVahed,
      dateBuy: model.dateBuy,
      dateRun: model.dateRun,
      type: model.type,

      //fixer: model.fixer,
      scopework: model.scopework,
      acceptanceCriteria: model.acceptanceCriteria,
      initialStatus: model.initialStatus,
      calibrationPeriod: model.calibrationPeriod,
      warningTime: model.warningTime,
      technicalSpecifications: model.technicalSpecifications,
      technicalDsc: model.technicalDsc,
      environmentalConditions: model.environmentalConditions,
      jobAlerts: model.jobAlerts,

      conditionKeep: model.conditionKeep,
      conditionTransport: model.conditionTransport,

      certificateNo: model.certificateNo,
      calibratingCompany: model.calibratingCompany,
      calibratingCustomer: model.calibratingCustomer,
      calibratingName: model.calibratingName,
      calibratingNameType: model.calibratingNameType,
      uncertainty: model.uncertainty,
      calDueType: model.calDueType,
      calDueMiladi: model.calDueMiladi,
      calDueShamsi: model.calDueShamsi,
      calDATEType: model.calDATEType,
      calDATEMiladi: model.calDATEMiladi,
      calDATEShamsi: model.calDATEShamsi,
      file: file,

      fixer: fixer,
      expert_calibration: AfradMojaz,
      gostateh: Local_Gostareh,

      calibratingprice: model.calibratingprice,
      calibratingpriceVahed: model.calibratingpriceVahed,

      cabinet_id: model.cabinet_id,
      category_id: model.category_id,
    }




    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/Edit", body, { headers }).pipe(
      map(data => {
        return data as DeviceBehfa_Interface
      })
    )

  }


  DeleteDevice(id: number,
    stause: number,
    dsc: String): Observable<DeviceBehfa_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/Delete?id=" + id +
      "&stause=" + stause +
      "&dsc=" + dsc ).pipe(
        map(data => {
          return data as DeviceBehfa_Interface
        })
      )
  }

  ConfirmUpload(
    id: number,
    operaiont: number,
    dsc: String
  ): Observable<DeviceBehfa_Interface> {

    return this.http.get(environment.BaseUrl
      + "Daro/DeviceBehfa/ConfirmUploadid=" + id
      + "&operaiont=" + operaiont
      + "&dsc=" + dsc
      ).pipe(
      map(data => {
        return data as DeviceBehfa_Interface
      })
    )
  }

  ConfirmUploadList(
    id: String,
    operaiont: number,
    dsc: String
  ): Observable<DeviceBehfa_Interface> {

    return this.http.get(environment.BaseUrl
      + "Daro/DeviceBehfa/ConfirmUploadList?id=" + id
      + "&operaiont=" + operaiont
      + "&dsc=" + dsc
      ).pipe(
      map(data => {
        return data as DeviceBehfa_Interface
      })
    )
  }

  PostDownload(code: Array<String>, Dowloadtype: number, LetterSchedules: number): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      Dowloadtype: Dowloadtype,
      LetterSchedule: LetterSchedules,
      code: code,
    }


    return this.http.post(environment.BaseUrl
      + "Daro/DeviceBehfa/PostDownload", body, { headers }).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )

  }

  PostUpload(code: Array<String>): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      Dowloadtype: 0,
      code: code,
    }


    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/PostUpload", body, { headers }).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )

  }

  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/Upload", body).pipe(
      map(data => {

        return data
      })
    )
  }

  uploadFileRepair(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/uploadRepair", body).pipe(
      map(data => {

        return data
      })
    )
  }



  PostRepair(id: number,
    file: Array<string>,
    Selected_FirstUser: string,
    dsc: string,
    device_id: number): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
      file: file,
      device_id: device_id,
      dsc: dsc,
      first_user_id_selected:Number(Selected_FirstUser)
    }

    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfa/PostRepair", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetSingleRepair(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetSingleRepair?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  PostAnswerFirst(id: Number, dsc: String, answer: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/PostAnswerFirst?id=" + id
      + "&dsc=" + dsc
      + "&answer=" + answer).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostAnswerSecond(contrator_id: Number, id: Number, dsc: String, answer: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/PostAnswerSecond?id=" + id
      + "&dsc=" + dsc
      + "&contrator_id=" + contrator_id
      + "&answer=" + answer).pipe(
        map(data => {
          return data as any
        })
      )
  }


  PostAnswerThird(third_phone: String,
    statu: Number,
    id: Number,
    third_price_id: Number,
    third_price: String,
    third_dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/PostAnswerThird?id=" + id
      + "&third_phone=" + third_phone
      + "&third_price=" + third_price
      + "&third_dsc=" + third_dsc
      + "&third_price_id=" + third_price_id
      + "&statu=" + statu).pipe(
        map(data => {
          return data as any
        })
      )
  }


  GetRecordPerformance(StartSearchDate: String,
    EndSearchDate: String,
    CodeBehfa: String,
    GroupFirst: number,
    GroupSecond: number,
    Filter_Type_Lap: number): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfa/GetRecordPerformance?StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&CodeBehfa=" + CodeBehfa
      + "&GroupFirst=" + GroupFirst
      + "&GroupSecond=" + GroupSecond
      + "&Filter_Type_Lap=" + Filter_Type_Lap).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

}
